import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import src from "../../../../../../images/nophoto_lg.png";

const useStyles = makeStyles(theme => ({
  root: {
    width: 240,
    height: 150,
    textAlign: "center"
  },
  image: {
    width: 150,
    height: 150,
    margin: "0 auto",
    borderRadius: "50%"
  }
}));

const Avatar = ({fileId}) => {
  const classes = useStyles();
  const baseURL = "/work/api/file";

  return <div className={classes.root}>
    {fileId ?
    <img className={classes.image} src={`${baseURL}/${fileId}`} />
  : <img className={classes.image} src={src} alt="Нет изображения" />}
  </div>
};

export default Avatar;
